import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiStepDTO,
  StepDTO,
} from "@lib/strapi/dtos/components/shared/step.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { getImageProps, ImageProps } from "@lib/image";

export class StepService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiStepDTO,
  ): Promise<StepDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new StepDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.description = await parseStrapiContent(strapiData.description);
    dto.image = getImageProps(strapiData.image);
    return dto;
  }
}
